import ProTransfer from './transfer';

export default ProTransfer;
